module.exports = "<app-navbar></app-navbar>\n<div class=\"app-content\">\n    <router-outlet></router-outlet>\n</div>\n\n"